(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-testimonials"] && !Shopify.designMode) return;
  try {
    
$('.cstmtestimonials-slider').slick({
  arrows: false,
  autoplay: autoplayStatus,
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    { breakpoint: 992, settings: { slidesToShow: 2 } },
    { breakpoint: 768, settings: { slidesToShow: 1 } }
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["revahs-email-gids"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.rvgids__form').forEach(function (form) {
    var section = form.closest('.rvgids');
    var input = form.querySelector('.rvgids__input');
    var btn = form.querySelector('.rvgids__btn');
    var btnLabel = form.querySelector('.rvgids__btn-label');
    var btnBusy = form.querySelector('.rvgids__btn-busy');
    var errorEl = form.querySelector('.rvgids__error');
    var successEl = section.querySelector('.rvgids__success');
    var companyId = form.getAttribute('data-company-id');
    var listId = form.getAttribute('data-list-id');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errorEl.hidden = true;
      input.classList.remove('is-invalid');

      var email = (input.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        input.classList.add('is-invalid');
        input.focus();
        return;
      }

      btn.disabled = true;
      btnLabel.hidden = true;
      btnBusy.hidden = false;

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Onderhoudsgids website',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: { gids_aangevraagd: true }
                  }
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: listId } }
            }
          }
        })
      }).then(function (res) {
        if (!res.ok) throw new Error('subscribe failed: ' + res.status);
        form.hidden = true;
        successEl.hidden = false;
      }).catch(function () {
        errorEl.hidden = false;
        btn.disabled = false;
        btnLabel.hidden = false;
        btnBusy.hidden = true;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
